<script lang="ts">
  export let showMask = false;
</script>
{#if showMask}
  <div
    class="share_img_mask"
    on:click={() => {
      showMask = false;
    }}
    on:keydown={() => {}}
    role="button"
    tabindex=0
  >
    <img
      src='https://vfiles.gtimg.cn/vupload/20210108/a5fd5a1610096574524.png'
      alt=""
    >
  </div>
{/if}

<style lang="scss">
.share_img_mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  img {
    display: block;
    width: 100%;
  }
}
</style>
